<template>
  <div class="contract-release-code" v-loading="loading">
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
      <el-select style="width: 220px" v-model="selectValue" @change="changeRpc()" :placeholder="this.$t('title.RPC_service')">
        <el-option v-for="item in options" :key="item.rpcUrl" :label="item.name" :value="item.rpcUrl"></el-option>
      </el-select>
      <el-select style="margin-left: 5%;width: 220px" v-model="selectChain" @change="changeChain()" :placeholder="$t('title.Please_select_the_chain')">
        <el-option v-for="item in options1" :key="item" :label="item+$t('title.chain')" :value="item"></el-option>
      </el-select>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
      <el-form-item prop="address">
        <el-input v-model="ruleForm.address" :placeholder="$t('title.Please_enter_the_address')"></el-input>
      </el-form-item>
      <el-button type="primary" @click="comparison">{{$t('title.get_contract_releas_code')}}</el-button>
    </el-form>
    <div class="layout">
      <div class="setting">
        <ul>
          <li>
            <label>{{ $t('title.theme') }}</label>
            <select v-model="theme">
              <option value>{{ this.$t('title.default') }}</option>
              <option value="one-dark">one-dark</option>
              <option value="vs-code">vs-code</option>
            </select>
          </li>
          <li>
            <label>{{ $t('title.Collapse_all') }}</label>
            <select v-model="closed">
              <option :value="false">false</option>
              <option :value="true">true</option>
            </select>
          </li>

          <li>
            <label>deep</label>
            <select v-model="deep">
              <option v-for="item in 10" :value="item">{{item}}</option>
            </select>
          </li>
          <li>
            <label>font-size</label>
            <select v-model="fontSize">
              <option v-for="item in 10" :value="item+11">{{item+11}}</option>
            </select>
          </li>
          <li>
            <label for="line-height">line-height</label>
            <select v-model="lineHeight">
              <option v-for="item in 20" :value="item*2+14">{{item*2+14}}</option>
            </select>
          </li>
        </ul>
      </div>
    </div>
    <div class="content">
      <json-view
        :data="json"
        :theme="theme"
        :deep="deep"
        :iconStyle="iconStyle"
        :fontSize="fontSize"
        :lineHeight="lineHeight"
        :closed="closed"
        :iconColor="iconColor"
      />
    </div>
  </div>
</template>

<script>
import {
	getrpcserver,
	getchaininfo,
} from "../../../api/interface";
import jsonView from "../../json-view/index.vue";
import request from '@/utils/request'
export default {
  name: "ContractReleaseCode",
  components: { jsonView },
  data() {
    return {
      ruleForm: {
        address: '',
      },
      rules: {
        address: [
          { required: true, message: this.$t('title.Please_enter_the_address'), trigger: 'change' }
        ]
      },
      loading: false,
      selectValue: "",
      options: "",
      selectChain: "",
      options1: "",
      browserUrl: '',
      json: {},
      theme: "",
      fontSize: 14,
      lineHeight: 24,
      deep: 3,
      iconStyle: "square",
      closed: false,
      color1: "",
      color2: "",
    };
  },
  methods: {
    comparison() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          request({
              url: `${this.browserUrl}/v1/getDeployContractAndDeployedByteCode/${this.ruleForm.address}`,
              method: 'get',
          }).then((res) => {
            if (res.code == '200') {
              this.json = res.data;
            } else {
              this.json = {}
              this.$message.error(res.msg);
            }
            this.loading = false
          }).catch((err) => {
            this.loading = false
          })
        } else {
          return false;
        }
      });
    },
    changeChain() {},
    changeRpc() {
      let data = { rpcServer: this.selectValue };
      getchaininfo(data).then(response => {
        this.options1 = response.data;
        this.selectChain = this.options1[0];
      });
    },
    getData() {
      getrpcserver().then(response => {
        this.options = response.data;
        this.selectValue = this.options[0].rpcUrl;
        this.browserUrl = this.options[0].browserUrl
        let data = { rpcServer: this.options[0].rpcUrl };
        getchaininfo(data).then(response => {
          this.options1 = response.data;
          this.selectChain = this.options1[0];
        });
      });
    },
  },
  computed: {
    iconColor() {
      const { color1, color2 } = this;

      if (color1 && color2) {
        return [color1, color2];
      } else {
        return [];
      }
    }
  },
  created() {
    this.getData()
  }
};
</script>
<style scoped lang="less">
  .contract-release-code {
    padding: 20px 30px;
    height: 100%;
  }
  .user_search {
    margin-bottom: 40px;
  }
  .el-form-item {
    width: 100%;
    margin-bottom: 40px;
  }
  .layout {
    margin-top: 60px;
    // min-width: 1000px;
    /*margin: 0 auto;*/

    h1 {
      font-size: 26px;
      font-weight: 400;
      margin: 12px 0;
    }

    a {
      display: block;
      background-color: #f8f8f9;
      border-radius: 4px;
      padding: 8px 16px;
      border: 1px solid #edeff0;
      border-radius: 4px;
      margin-bottom: 20px;
      text-decoration: none;
      color: #2d8cf0;
    }

    .setting {
      border: 1px solid #ccc;
      padding: 10px 20px;

      h3 {
        line-height: 1.6;
        font-size: 18px;
        color: #333;
      }
    }

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;

      li {
        display: flex;
        align-items: center;
        padding: 10px 0;
        padding-right: 20px;

        label {
          font-size: 13px;
          padding-right: 10px;
          color: #333;
        }

        select {
          display: block;
          width: 80px;
          height: 28px;
          background: #fff;
        }
      }
    }
  }
  .content {
    border: 1px solid #ccc;
    border-top: none;
    max-height: 380px;
    overflow: auto;
    // min-width: 1000px;
    /*.content-wrap {*/
    /*   display: none !important;*/
    /*   background-color: rebeccapurple;*/
    /*}*/
  }
</style>
